// 驗證相關請求（登入、token 刷新等），baseURL 指向使用者系統。
// 皆為 public 端點，不帶 Bearer Token，但仍需 xsrf 保護與統一錯誤處理。
import axios from 'axios';
import { attachResponseInterceptor } from './interceptors';

const authRequest = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API_USER_SYSTEM_URL : '',
  withCredentials: true,
  xsrfHeaderName: 'xsrf-token',
  xsrfCookieName: 'xsrf-token',
});

attachResponseInterceptor(authRequest);

export default authRequest;
